import m from "../../es2015/lang/et_EE";
window.am4lang_et_EE = m;


//////////////////
// WEBPACK FOOTER
// ./lang/et_EE.js
// module id = null
// module chunks = 